export default "__VITE_ASSET__DUCootPZ__"